import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class AgingRiscoPontoControleRevisao extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/AgingPontoControleRevisaoLookup" {...this.props} />;
  }
}

export default AgingRiscoPontoControleRevisao;
